<template>
	<button class="btn btn-border btn--color btn-request" @click="ShowCollaborationFeebackPopup = !ShowCollaborationFeebackPopup">Заявка на сотрудничество</button>
	<transition name="modal">
		<CollaborationFeebackPopup :legal="legal" :edi="edi" :productControl="productControl"  v-if="ShowCollaborationFeebackPopup" @close="ShowCollaborationFeebackPopup = false" />
	</transition>
</template>

<script>
import CollaborationFeebackPopup from "@/components/forms/CollaborationFeebackPopup.vue";

export default {
	name: 'RequestBtn',
	components: {CollaborationFeebackPopup},
	props: {
		legal: {
			type: Array,
			default: () => []
		},
		edi: {
			type: Array,
			default: () => []
		},
		productControl: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			ShowCollaborationFeebackPopup: false
		}
	},
}
</script>
